import { LuPhone, LuClock } from "react-icons/lu";

import { business } from "../content/site";

/**
 * Full-width call-to-action band that sits between page sections.
 *
 * Brand surface + `on-inverse` so the global focus ring flips to white and
 * stays visible against the blue. Stacks and centres below `md`, becomes a
 * row above it.
 */
const ScheduleBannerCallOnly = () => (
  <section
    aria-labelledby="schedule-banner-heading"
    className="on-inverse bg-surface-brand text-ink-inverse section-tight"
  >
    <div className="container-page">
      <div className="flex flex-col items-center gap-6 text-center md:flex-row md:items-center md:justify-between md:gap-8 md:text-left">
        {/* Message */}
        <div className="min-w-0 max-w-prose">
          <h2
            id="schedule-banner-heading"
            className="text-heading-lg text-ink-inverse"
          >
            Something in the house not working right?
          </h2>
          <p className="mt-2 text-body-lg text-ink-inverse">
            Tell us what is happening and we will tell you what it takes to fix
            it.
          </p>

          {/*
            Posted hours are deliberately omitted — availability moves with the
            current job load, so a fixed schedule would be a promise we cannot
            keep. We say what is actually true instead. If `business.hours` is
            ever set, that takes precedence and renders here.
          */}
          {business.hours ? (
            <p className="mt-3 flex items-center justify-center gap-2 text-body-sm text-ink-inverse md:justify-start">
              <LuClock aria-hidden="true" className="h-4 w-4 shrink-0" />
              <span>{business.hours.weekday}</span>
            </p>
          ) : (
            business.availabilityNote && (
              <p className="mt-3 flex items-start justify-center gap-2 text-body-sm text-ink-inverse md:justify-start">
                <LuClock
                  aria-hidden="true"
                  className="mt-1 h-4 w-4 shrink-0"
                />
                <span className="max-w-prose">{business.availabilityNote}</span>
              </p>
            )
          )}
        </div>

        {/* Actions. The digits are the CTA, not the word "call". */}
        <div className="flex w-full flex-col items-stretch gap-3 sm:w-auto sm:flex-row sm:items-center md:shrink-0">
          <a
            href={business.phone.href}
            className="btn-urgent w-full text-body-lg sm:w-auto"
          >
            <LuPhone aria-hidden="true" className="h-5 w-5 shrink-0" />
            <span className="tabular">{business.phone.display}</span>
          </a>

          <a href="#contact" className="btn-outline-inverse w-full sm:w-auto">
            Request service
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default ScheduleBannerCallOnly;
